import Vue from 'vue';
import VueRouter from 'vue-router';
import home from '../views/Home.vue';

const login = () => import('@/views/login/index.vue');
const wxLogin = () => import('@/views/login/wxlogin.vue');
const bindPhone = () => import('@/views/login/bindphone.vue');
const details = () => import('@/views/details/index.vue');
const classify = () => import('@/views/classify/index.vue');
const orderConfirm = () => import('@/views/order/orderconfirm.vue');
const orderDetails = () => import('@/views/order/orderdetails.vue');
const payment = () => import('@/views/payment/payment.vue');
const paymentWx = () => import('@/views/payment/wxpayment.vue');
const paymentSuccess = () => import('@/views/payment/paymentsuccess.vue');
const transferPayment = () => import('@/views/payment/transfer-payment.vue');
const orderList = () => import('@/views/order/orderlist.vue');
const logistics = () => import('@/views/order/logistics.vue');
const card = () => import('@/views/card/index.vue');
const user = () => import('@/views/user/mycenter.vue');
const userInfor = () => import('@/views/user/userinfor.vue');
const address = () => import('@/views/user/address.vue');
const securitySet = () => import('@/views/user/securityset.vue');
const invoice = () => import('@/views/user/invoice.vue');
const invoiceEdit = () => import('@/views/user/invoiceedit.vue');
const exchange = () => import('@/views/exchange/index.vue');
const exchangeList = () => import('@/views/exchange/list.vue');
const exchangeDetails = () => import('@/views/exchange/details.vue');
const exchangeSuccess = () => import('@/views/exchange/success.vue');
const grade = () => import('@/views/user/grade.vue');
const Comment = () => import('@/views/evaluate/comment.vue');
const evaluateList = () => import('@/views/evaluate/list.vue');
const feedback = () => import('@/views/user/feedback.vue');
const notifys = () => import('@/views/notifys/index.vue');
const integral = () => import('@/views/user/integral.vue');
const integralDetails = () => import('@/views/user/integralDetails.vue');
const bargain = () => import('@/views/bargain/bargain.vue');
const coupon = () => import('@/views/user/coupon.vue');
const special = () => import('@/views/special/special.vue');
const couponList = () => import('@/views/classify/couponList.vue');
const consumables = () => import('@/views/consumables/consumables.vue');
const consumablesMaterial = () => import('@/views/consumables/consumables-material.vue');
const consumablesDetails = () => import('@/views/consumables/details.vue');
const consumablesOrderDetails = () => import('@/views/consumables/order-details.vue');
const consumablesOrderList = () => import('@/views/consumables/order-list.vue');
const material = () => import('@/views/consumables/material.vue');
const size = () => import('@/views/consumables/size.vue');
const infor = () => import('@/views/consumables/infor.vue');
const selectTag = () => import('@/views/consumables/selecttag.vue');
const product = () => import('@/views/consumables/product.vue');
const materialSuccess = () => import('@/views/consumables/success.vue');
const firstPurchase = () => import('@/views/activity/firstpurchase.vue');
const flashsale = () => import('@/views/flashsale/flashsale.vue');
const doubleTwelve = () => import('@/views/activity/double-twelve.vue');
const landingPage = () => import('@/views/activity/landing-page.vue');
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
    // meta: {
    //   keepAlive: true
    // }
  },
  // 注册登录
  {
    path: '/login',
    name: 'login',
    component: login
  },
  // 微信扫码登录
  {
    path: '/wxlogin',
    name: 'wxLogin',
    component: wxLogin
  },
  {
    path: '/details',
    name: 'details',
    component: details
  },
  // 商品分类
  {
    path: '/classify',
    name: 'classify',
    component: classify
    // meta: {
    //   keepAlive: true,
    // },
  },
  {
    path: '/user',
    name: 'user',
    component: user
    // meta: {
    //   keepAlive: true
    // }
  },
  {
    path: '/userinfor',
    name: 'userInfor',
    component: userInfor
  },
  {
    path: '/double-twelve',
    name: 'doubleTwelve',
    component: doubleTwelve
  },
  {
    path: '/address',
    name: 'address',
    component: address
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: invoice
  },
  {
    path: '/invoiceedit',
    name: 'invoiceEdit',
    component: invoiceEdit
  },
  // 确认订单
  {
    path: '/orderconfirm',
    name: 'orderConfirm',
    component: orderConfirm
  },
  // 订单列表
  {
    path: '/order-list',
    name: 'orderList',
    component: orderList,
    meta: {
      keepAlive: true,
      requireAuth: true,
      isBack: false
    }
  },
  // 订单详情
  {
    path: '/order-details',
    name: 'orderDetails',
    component: orderDetails
  },
  // 物流信息
  {
    path: '/logistics',
    name: 'logistics',
    component: logistics,
    meta: {
      requireAuth: true
    }
  },
  // 购物车
  {
    path: '/card',
    name: 'card',
    component: card,
    meta: {
      requireAuth: true // 判断是否需要登录
    }
  },
  // 安全设置
  {
    path: '/securityset',
    name: 'securitySet',
    component: securitySet,
    meta: {
      requireAuth: true // 判断是否需要登录
    }
  },
  // 微信扫码用户绑定手机号码
  {
    path: '/bindphone',
    name: 'bindPhone',
    component: bindPhone
  },
  // 微信支付宝支付
  {
    path: '/payment',
    name: 'payment',
    component: payment
  },
  // 微信支付
  {
    path: '/paymentwx',
    name: 'paymentWx',
    component: paymentWx
  },
  // 微信支付
  {
    path: '/payment-success',
    name: 'paymentSuccess',
    component: paymentSuccess
  },
  // 对公打款进度
  {
    path: '/transfer-payment',
    name: 'transferPayment',
    component: transferPayment
  },
  // 退换货列表
  {
    path: '/exchange',
    name: 'exchange',
    component: exchange
  },
  // 服务单详情
  {
    path: '/exchange-details',
    name: 'exchangeDetails',
    component: exchangeDetails
  },
  // 申请售后成功
  {
    path: '/exchange-success',
    name: 'exchangeSuccess',
    component: exchangeSuccess
  },
  // 退换货列表
  {
    path: '/exchange-list',
    name: 'exchangeList',
    component: exchangeList,
    meta: {
      keepAlive: true,
      requireAuth: true,
      isBack: false
    }
  },
  // 等级中心
  {
    path: '/grade',
    name: 'grade',
    component: grade
  },
  // 我的积分
  {
    path: '/integral',
    name: 'integral',
    component: integral
  },
  // 砍价中心
  {
    path: '/bargain',
    name: 'bargain',
    component: bargain
  },
  // 积分明细
  {
    path: '/integralDetails',
    name: 'integralDetails',
    component: integralDetails
  },
  // 发表评论
  {
    path: '/comment',
    name: 'Comment',
    component: Comment
  },
  // 评价晒图
  {
    path: '/evaluation-list',
    name: 'evaluationList',
    component: evaluateList
  },
  // 意见反馈
  {
    path: '/feedback',
    name: 'feedback',
    component: feedback
  },
  // 消息通知
  {
    path: '/notifys',
    name: 'notifys',
    component: notifys
  },
  // 优惠券
  {
    path: '/coupon',
    name: 'coupon',
    component: coupon
  },
  // 导航主题
  {
    path: '/special',
    name: 'special',
    component: special
  },
  // 优惠券商品列表
  {
    path: '/couponList',
    name: 'couponList',
    component: couponList
  },
  {
    path: '/consumables',
    name: 'consumables',
    component: consumables
  },
  {
    path: '/consumables-details',
    name: 'consumablesDetails',
    component: consumablesDetails
  },
  {
    path: '/consumables-orderdetails',
    name: 'consumablesOrderDetails',
    component: consumablesOrderDetails
  },
  {
    path: '/consumables-orderlist',
    name: 'consumablesOrderList',
    component: consumablesOrderList
  },
  {
    path: '/consumables-terial',
    name: 'consumablesMaterial',
    component: consumablesMaterial,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/erial',
    name: 'material',
    component: material,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/erial-size',
    name: 'size',
    component: size
  },
  {
    path: '/erial-infor',
    name: 'infor',
    component: infor
  },
  {
    path: '/erial-selecttag',
    name: 'selectTag',
    component: selectTag
  },
  {
    path: '/erial-product',
    name: 'product',
    component: product,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/erial-success',
    name: 'materialSuccess',
    component: materialSuccess
  },
  // 首购特惠优惠券
  {
    path: '/first-purchase',
    name: 'firstPurchase',
    component: firstPurchase
  },
  // 限时抢购
  {
    path: '/flash-sale',
    name: 'flashsale',
    component: flashsale
  },
  // 活动页
  {
    path: '/landing-page',
    name: 'landingPage',
    component: landingPage
  }
];

const router = new VueRouter({
  mode: 'history',
  // base: '/pc',
  routes
});

export default router;
